import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MODULE_ROUTES = {
  dairy: '/dairy',
  chemicals: '/chemicals',
  agriculture: '/agriculture',
  adhesive: '/adhesive',
};

// Owners see everything. Everyone else — module_admin and
// operator alike — is confined to the module on their account.
const isOwner = (u) => u?.role === 'businessman' || u?.role === 'admin';

const ProtectedRoute = ({ children, allowedRoles, module }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        color: '#666',
        fontFamily: "'Inter', sans-serif"
      }}>
        Loading...
      </div>
    );
  }

  // Not logged in → go to login
  if (!user) return <Navigate to="/login" />;

  if (!isOwner(user)) {
    const home = MODULE_ROUTES[user.business_module];

    // No module on the account. Redirecting would loop, so say so.
    if (!home) {
      return (
        <div style={{ padding: '60px', textAlign: 'center', fontFamily: "'Inter', sans-serif", color: '#666' }}>
          No module is assigned to this account. Ask the owner to set one.
        </div>
      );
    }

    // Owner-only pages (main dashboard, HR)
    if (allowedRoles && !allowedRoles.includes(user.role)) {
      return <Navigate to={home} replace />;
    }

    // Another module's pages
    if (module && module !== user.business_module) {
      return <Navigate to={home} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;